<script setup lang="ts">
import { onScopeDispose, ref, watch } from 'vue';

/**
 * The site's one authored motion. When a live figure changes, it lifts to
 * white and eases back to its own colour over 600ms. A colour transition on
 * change, never a running animation, so an idle board repaints nothing.
 */
const props = defineProps<{ value: number; text: string }>();

const lifted = ref(false);
let timer: ReturnType<typeof setTimeout> | undefined;

watch(
  () => props.value,
  (next, previous) => {
    if (next === previous) return;
    lifted.value = true;
    clearTimeout(timer);
    timer = setTimeout(() => {
      lifted.value = false;
    }, 90);
  },
);

onScopeDispose(() => clearTimeout(timer));
</script>

<template>
  <span class="tick tabular-nums" :class="{ 'tick-lift': lifted }" :style="lifted ? { color: '#fdfdfd' } : undefined">
    {{ text }}
  </span>
</template>
